import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import validateQueryParams from "../helpers/validateQueryParams";

function AuthGuard({ component: Component, ...rest }) {
  const location = useLocation();
  const queryParams = queryString.parse(location.search);
  const { error } = validateQueryParams(queryParams);

  if (error) {
    return <Navigate to={"/unauthorized"} />;
  }
  return <Outlet />;
}

export default AuthGuard;
